// extracted by mini-css-extract-plugin
export default {"wrapper":"JC-z","viewport":"KC-z","container":"LC-z","slide":"MC-z"};